import axios from 'axios'

const iniciarPinpad = async function () {
  console.log('=== iniciarPinpad iniciou ===')

  const apiUrl = `${process.env.VUE_APP_PINPAD_API_URL}/totem/inicializar.php`

  const headers = {
    'Content-Type': 'application/json'
  }

  try {
    const response = await axios.post(apiUrl, {}, { headers })
    
    // console.log('iniciarPinpad sucesso:', response.data)
    
    if (response.data?.sucesso === true) {
      return response.data
    }

    throw new Error(response.data?.mensagem || 'Falha ao iniciar PinPad')
  } catch (error) {
    console.error('Erro no axios.post de iniciarPinpad:', error.response?.data || error.message)
    throw error
  }
}

export { iniciarPinpad }